/**
 * Signal gauge: the device's signal percentage (device.signal, 0-100) as four
 * rising bars, a quarter of the range each, drawn like the battery's bars.
 */

export const SIGNAL_BARS = 4;

/** 4 bars from 75%, 3 from 50%, 2 from 25%, 1 below that; 0 with no reading. */
export function signalBars(percent) {
  if (!(percent > 0)) return 0;
  if (percent >= 75) return 4;
  if (percent >= 50) return 3;
  if (percent >= 25) return 2;
  return 1;
}

/**
 * "ok" for 3 or 4 bars, drawn gray like the icons beside them; "low" (yellow)
 * for 2 and "critical" (red) for 1, the battery's warning colours.
 */
export function signalLevel(bars) {
  if (bars <= 1) return "critical";
  if (bars === 2) return "low";
  return "ok";
}

/** Tooltip and screen-reader text for the bars. */
export function signalLabel(bars) {
  return `Signal ${bars} of ${SIGNAL_BARS} bars`;
}
